import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import { reExportedColors, ITooltip } from '../../index'

const PlusIconButton = ({ className, onClick, disabled, sx }) => (
  <ITooltip placement='top' content='Show'>
    <IconButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      sx={[
        {
          background: reExportedColors.DARK_GREY,
          border: `2px solid ${reExportedColors.DARK_GREY}`,
          '&:hover': {
            background: '#fff',
            border: `2px solid ${reExportedColors.DARK_GREY}`
          },
          '& .MuiSvgIcon-root': { color: '#fff' }
        },
        ...(Array.isArray(sx) ? sx : [sx]).filter(Boolean)
      ]}
    >
      <AddIcon />
    </IconButton>
  </ITooltip>
)

export default PlusIconButton
